import React, {Fragment} from 'react';
import {connect} from "react-redux";
import classNames from 'classnames';
import $ from 'jquery';

import {
  toggleDesktopNavigation,
  setActiveNavigationNames,
  setModuleContextMenuType,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setNavigationViewType,
  setNavigationLoading,
  toggleNavItemPositionModal
} from "../../../actions/navigationFunctions";
import {
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex,
  updateCanvasCount
} from "../../../actions/actionFunctions";
import DesktopNavigationCommon from "../../visComponents/navigation/desktopNavigationCommon";
import {getCurrentLayout} from "../../appLayout";

import LockedView from "../../common/lockedView";
import {ContentType} from "../../visComponents/constants";
import ContextMenuQKB from "./contextMenuQKB";
import MobileMenuSelect from "../../visComponents/navigation/mobile/mobileMenuSelect";
import {setVisualizerTutorialStep, showVisualizerTutorial} from "../../../actions/tutorialFunctions";
import {Vanity} from "../core/parts/vanity";
import NavItemPositionModal from "../../visComponents/navigation/navItemPositionModal";
import {checkForContextMenuCommon} from "../lookNavigation/lookFunctions";
import {setLookContextMenu} from "../../../actions/lookFunctions";
import goToMaterialPage from "../../common/goToMaterialPage";

class DesktopNavigation extends DesktopNavigationCommon {

  bindCanvasClick = (event) => {
    // const canvas = document.getElementById(this.props.canvasId);
    this.props.setHoveredLayer(event);

    if (document.hoveredLayer) {

      if (this.checkForContextMenu(document.hoveredLayer, event)) {
        return false
      }

      const hoveredPartId = document.hoveredLayer.partId;

      if (hoveredPartId) {
        if (this.state.contentType === 0) {
          this.setState({
            showNavigation: true,
            contentType: ContentType.Design,
            hoveredLayer: {}
          }, () => {
            this.setNewActiveFeature();
            this.menuOpened();
            setTimeout(() => {
              $(document).on('click', this.handleWrapperBlur);
            }, 0)
          });
        }

        const layout = getCurrentLayout();
        const featureGroup = layout.getFeatureGroupByPartId(hoveredPartId);
        if (featureGroup) {
          this.triggerOpenNavigationMenu(featureGroup.partName, featureGroup.getParent().partName)
        }
      }
    }

  };

  checkForContextMenu = (hoveredLayer, event) => {
    if (this.props.contextMenu.opened) {
      this.props.setLookContextMenu({
        opened: false
      })
      return true
    }
    if (!hoveredLayer) {
      return false
    }

    const {showButtons} = checkForContextMenuCommon(hoveredLayer.partId, hoveredLayer.layerPosition);
    if ((showButtons.length > 1) && !(hoveredLayer.partId && hoveredLayer.partId === "vanity_legs")) {
      this.props.setLookContextMenu({
        opened: true,
        partId: hoveredLayer.partId,
        layerPosition: hoveredLayer.layerPosition, // if needed
        position: {
          x: event.clientX,
          y: event.clientY,
        }
      });
      return true
    } else if (showButtons.length === 1 && showButtons[0].isWizard) {
      goToMaterialPage("visualizer", false, null, "",
        {wizardItemId: showButtons.wizardId, quoteIndex: this.props.activeQuoteIndex});
      return true
    }
    return false
  }

  handleContextMenuClick = (featureToClick, partId) => {
    const layout = getCurrentLayout();
    let clickedParent = "", clickedButton = "";
    const featureGroup = layout.getFeatureGroupByPartId(partId);
    if (featureGroup) {
      clickedButton = featureGroup.partName;
      clickedParent = featureGroup.getParent().partName;
    }
    // console.log('clickedButton', clickedButton);
    // console.log('clickedParent', clickedParent);
    if (!clickedButton) {
      return
    }
    // console.log('menuItem', menuItem);
    // if (clickedParent === "Walls" && (clickedButton === "Left Shower Wall" || clickedButton === "Pony Wall")) {
    //   this.ponyWallAndLeftWallClick(menuItem);
    // }

    this.setState({
      showNavigation: true,
      contentType: ContentType.Design,
      contextMenuOpen: false,
      hoveredLayer: {}
    }, () => {
      this.menuOpened();
      this.triggerOpenNavigationMenu(clickedButton, clickedParent);
      $(document).on('click', this.handleWrapperBlur);
      this.setNewActiveFeature();
      if (featureToClick) {
        featureToClick.handleClick();
      }
    });
  };

  handleNavigationItemClick = (item, ignoreLocked = false, featureIsLocked, event) => {

    if (this.state.childNavigationItem
      && this.state.childNavigationItem.part.activeFeature
      && Array.isArray(this.state.childNavigationItem.part.activeFeature.metaData["SkuName"])
      && this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0]
      && Array.isArray(item.part.metaData["SkuName"])
      && (this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0] === item.part.metaData["SkuName"][0])) {
      this.showPositionsPopup(item, event); // move modal to new position
      return false // don't change L to R // redundant click
    }

    const layout = getCurrentLayout();
    this.navigationItemClickCommon(item); // set active feature

    const showPositionPopup = this.showPositionsPopup(item, event);
    if (showPositionPopup) {
      return // don't click on feature!! we are clicking inside the modal window
    }

    const updateSideBarIds = ["shower_body", "wall_configuration", "vanity_cabinet", "shower_pan_combo"];
    if (updateSideBarIds.includes(item.part.partId)) {
      this.updateSideBar();
    } else if (this.state.parentNavigationItem && this.state.parentNavigationItem.text === "Shower Tub Combo"
      && item.part.bottomTubId && (this.state.parentNavigationItem.part.bottomTub !== item.part.bottomTubId)) {
      this.updateSideBar();
    }

    // console.log('this.state.parentNavigationItem', this.state.parentNavigationItem);
    // console.log('this.state.parentNavigationItem.part.subParts()', this.state.parentNavigationItem && this.state.parentNavigationItem.part && this.state.parentNavigationItem.part.subParts());

    if (item.matchesMetaFailed) {
      let nonCompatibleWith = "";
      switch (item.part.partId) {
        case "vanity_faucet":
          nonCompatibleWith = "sink";
          break;
        case "sink":
          nonCompatibleWith = "vanity";
          break;
        case "shower_pod":
          nonCompatibleWith = "Window Kit";
          break;
        case "window_kits":
          nonCompatibleWith = item.matchesMetaFailed === "shower_pod" ? "Shower Pod" : "Corner Shelf";
          break;
        default:
          break;
      }
      this.callMetaMathesFailedPopup(item, nonCompatibleWith);
    // } else if (item.part.partId === "vanity_sink" && this.state.parentNavigationItem.part.faucet
    //   && this.state.parentNavigationItem.part.faucet.placeholderChanged
    //   && this.state.parentNavigationItem.part.faucet.activeFeature) {
    //
    //   const sinkSizeConditionValue = item.part.metaData["SinkSize"][0];
    //
    //   if (this.state.parentNavigationItem.part.faucet.activeFeature.matchesMetaForCondition('SinkSize', sinkSizeConditionValue)) {
    //     this.itemClick(item, ignoreLocked)
    //   } else {
    //     this.callMetaMathesFailedPopup(item, 'faucet');
    //   }
    } else if (item.part.partId === "toilet") {
      const vanity = layout.parts[Vanity.id];
      const counterTopSize = vanity.counterTopSize(item.part);
      if (counterTopSize === "60in" || counterTopSize === "72in") {
        this.callToiletFailPopup('toilet', item, ignoreLocked)
      } else {
        this.itemClick(item, ignoreLocked)
      }
    } else if (item.part.partId === "vanity_cabinet") {
      // let toilet = layout.parts[Toilet.id];
      // if (toilet) {
      //   toilet = toilet.toilet; // toiletBody
      // }
      // const counterTopSize = item.part.vanitySize + 'in';
      // const vanity = layout.parts[Vanity.id];
      // const currentCounterTopSize = vanity.counterTopSize(item.part);
      // if (toilet && toilet.placeholderChanged && (counterTopSize === "60in" || counterTopSize === "72in")
      //   && (currentCounterTopSize !== "60in" && currentCounterTopSize !== "72in")) {
      //   this.callToiletFailPopup('vanity', item, ignoreLocked)
      // } else {
      //   this.itemClick(item, ignoreLocked);
      // }
      this.itemClick(item, ignoreLocked);
      if (this.props.fabricatorSettings
        && (this.props.fabricatorSettings.wizardConsumers || (this.props.fabricatorSettings.wizardClients && document.kvConfig.isBackend))
      ) {
        if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
          this.setWizardFiltersFromActiveItem(item.part)
        }
      }
    } else if (item.part.partId === "shower_interior_wall") {
      if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
        this.setWizardFiltersFromActiveItem(item.part)
      }
      this.itemClick(item, ignoreLocked)
    } else {
      this.itemClick(item, ignoreLocked)
    }

    if (this.state.parentNavigationItem) {  // update canvas only if it is child
      this.props.updateCanvasCount();
    }

  };

  render() {
    const layout = getCurrentLayout();
    // const fabricatorSettings = this.props.fabricatorSettings;
    const activePart = this.state.parentNavigationItem ? this.state.parentNavigationItem.part : null;
    const activeSubPart = this.state.childNavigationItem ? this.state.childNavigationItem.part : null;
    // const activeNavPart = activeSubPart || activePart;
    const parentItems = layout.designNavigationItems();  // parent list without filters

    const useWizard = false, wizardGroups = [];

    let showNavigationFiltersSteps = false;

    if (activeSubPart && activeSubPart.canUseNavigationFilterSteps
      && activeSubPart.canUseNavigationFilterSteps()) {
      showNavigationFiltersSteps = !this.props.countertopNavigationFilterCompleted;
    }

    const showLockedView = this.currentActiveItemIsLocked(useWizard);

    const useFilters = false;
    const availableNavButtons = [ContentType.Design, ContentType.Layout, ContentType.DisplayRoom, ContentType.RoomScene];

    return (
      <Fragment>
        <div className={classNames('nav-overlay', {'nav-overlay--fullwidth': this.state.showNavigation})}>
          <div
            className={classNames('nav', {'nav--opened': this.state.showNavigation}, 'nav--' + this.state.contentType)}>
            <div className="nav-wrapper" ref={(node) => this.navWrapper = node}>
              <div className="nav-wrapper__content">
                <div className="nav-wrapper__content-body">
                  {this.content(useWizard, wizardGroups, useFilters, activePart, activeSubPart)}
                </div>
                <button className="nav-wrapper__content-close" onClick={this.closeNavigation}/>
              </div>
              {this.navigationMenuButtons(availableNavButtons)}
              {showNavigationFiltersSteps ? null : (
                <div className="nav-wrapper__select" onClickCapture={this.handleMobileSelectClick}>
                  <MobileMenuSelect parentItems={parentItems}
                                    desktop={true}
                                    opened={this.state.showNavigation}
                                    activePart={activePart}
                                    activeSubPart={activeSubPart}
                                    onSubPartClick={this.handleSubPartClick}
                                    onParentItemClick={this.handleParentItemClick}/>
                </div>
              )}
              {/*<div className="nav-wrapper__search">*/}
              {/*<div className="search">*/}
              {/*<input className={"search-input" + (this.state.searchText ? " search-input--no-icon" : "")}*/}
              {/*value={this.state.searchText}*/}
              {/*onChange={this.handleSearchInputChange} placeholder="search"/>*/}
              {/*</div>*/}
              {/*</div>*/}
            </div>
          </div>
          {this.props.bvOpened ? <NavItemPositionModal activeFeature={this.props.activeFeature}/> : null}
          {showLockedView
            ? <LockedView setActiveFeature={this.resetActiveFeature} handleUserLoginClick={this.handleUserLoginClick}/>
            : null}
        </div>
        <ContextMenuQKB handleContextMenuClick={this.handleContextMenuClick}
                        renderGreenLayerByZindex={this.props.renderGreenLayerByZindex} />
      </Fragment>
    )
  }

}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;

  return {
    filtersVisible: store.filterState.showFilters,
    filterGroups: store.filterState.filterGroups,
    bvPresets: store.bathroomVisualizerState.bvPresets,
    bvOpened: store.bathroomVisualizerState.bvOpened,
    userIsLoggedIn: store.userState.userIsLoggedIn,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    activeNavigationFilter: store.navigationState.activeNavigationFilter,
    countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
    visualizerTutorialStep: store.tutorialState.visualizerTutorialStep,
    visualizerTutorialIsOpened: store.tutorialState.visualizerTutorialIsOpened,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    navItemPositionModal: store.navigationState.navItemPositionModal,
    contextMenu,
    fabricatorData: store.fabricatorState,
  }
};

const mapDispatchToProps = {
  setNavigationViewType,
  toggleDesktopNavigation,
  setActiveNavigationNames,
  setModuleContextMenuType,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex,
  setVisualizerTutorialStep,
  showVisualizerTutorial,
  setNavigationLoading,
  toggleNavItemPositionModal,
  updateCanvasCount,
  setLookContextMenu,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {forwardRef: true}
)(DesktopNavigation);
